module.exports = __webpack_public_path__ + "media/images/app/collections/collection-diamond-mobile-742b4b1de4ae4773091c3fd675a441f9.webp";